import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { Reply } from '../types';
import { formatRelativeTime } from '../utils/rantUtils';
import { renderTextWithLinks } from '../utils/textUtils';
import { updateReplyVote } from '../services/replyService';
interface ReplyCardProps {
  reply: Reply;
  onReplyUpdated: () => void;
}
export const ReplyCard: React.FC<ReplyCardProps> = ({
  reply,
  onReplyUpdated
}) => {
  const [isVoting, setIsVoting] = useState(false);
  const relativeTime = formatRelativeTime(reply.timestamp);
  const handleVote = async () => {
    if (reply.hasVoted || isVoting) return;
    setIsVoting(true);
    try {
      await updateReplyVote(reply.id);
      onReplyUpdated();
    } catch (error) {
      console.error('Failed to vote on reply:', error);
    } finally {
      setIsVoting(false);
    }
  };
  return <motion.div className="bg-background-light rounded-lg p-4 hover:bg-opacity-80 transition-all" initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2
  }} data-id="element-113">
      <div className="flex gap-3" data-id="element-114">
        <div className="flex flex-col items-center gap-1 pt-1" data-id="element-115">
          <motion.button onClick={handleVote} className={`flex flex-col items-center justify-center w-10 h-10 rounded-lg transition-all ${reply.hasVoted ? 'bg-primary/20 text-primary cursor-default' : 'bg-background hover:bg-primary/10 hover:text-primary text-text-secondary'}`} whileHover={{
          scale: reply.hasVoted ? 1 : 1.1
        }} whileTap={{
          scale: reply.hasVoted ? 1 : 0.9
        }} disabled={reply.hasVoted || isVoting} data-id="element-116">
            <FlameIcon className="h-4 w-4" data-id="element-117" />
            <span className="text-xs font-bold mt-0.5" data-id="element-118">{reply.votes}</span>
          </motion.button>
        </div>
        <div className="flex-1 min-w-0" data-id="element-119">
          <div className="flex items-center gap-2 mb-2" data-id="element-120">
            <span className="text-sm font-semibold text-text-primary" data-id="element-121">
              Anonymous
            </span>
            <span className="text-xs text-text-secondary" data-id="element-122">•</span>
            <span className="text-xs text-text-secondary" data-id="element-123">{relativeTime}</span>
          </div>
          <p className="text-text-primary leading-relaxed" data-id="element-124">
            {renderTextWithLinks(reply.text)}
          </p>
        </div>
      </div>
    </motion.div>;
};